import {
  Component,
  ChangeDetectionStrategy,
  ViewEncapsulation,
  OnInit,
  inject,
  computed,
  DOCUMENT,
  signal,
} from '@angular/core';
import { SwUpdate } from '@angular/service-worker';
import { RouterOutlet } from '@angular/router';
import { AuthService, ConfigService } from '@assist/shared/data';
import { FaviconService } from '@cue/utilities';
import { SignalRService } from '@cue/api';
import { injectDestroy } from 'ngxtension/inject-destroy';
import { takeUntil, tap } from 'rxjs';

@Component({
  selector: 'cue-root',
  templateUrl: './not-enabled-app.component.html',
  styleUrls: ['./not-enabled-app.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [],
})
export class NotEnabledAppComponent implements OnInit {
  private doc = inject(DOCUMENT);

  issue = signal<'not-configured' | 'missing-license' | null>(null);
  // reasony
  // not-configured  - neni nastavena
  // missing-license - není licence
  ngOnInit() {
    const el = this.doc.getElementById('appLoading');
    if (el) {
      el.parentElement.removeChild(el);
    }

    // read query string param from url
    const queryParams = new URLSearchParams(window.location.search);
    const issue = queryParams.get('bootstrapIssue');
    if (issue) {
      this.issue.set(issue as unknown as 'not-configured' | 'missing-license');
    }
  }
}
